import MachinesRoutes from '@/pages/student/components/machine/router';

export default [
  {
    path: 'student',
    component: () => import('@/pages/student/Student'),
    meta: {
      requiresAuth: true,
      role: 'student',
    },
    children: [
      {
        path: '',
        redirect: 'machines',
      },
      ...MachinesRoutes,
    ]
  },
];
